import type {
  AIVisibilityDataTableProps,
  AIVisibilitySentimentProps,
  BaseChartLibraryProps,
  BroadcastTimeByMediaTypeData,
  ChartLibraryData,
  ChartLibraryProps,
  LeadingSourcesChartLibraryProps,
  LeadingSourcesTableChartLibraryProps,
  OutreachPerformanceChartLibraryProps,
  WordCloudProps,
} from "shared/modules/Charts/types/data";
import type { Nullable } from "shared/types";

export function isChartLibraryData(
  data: ChartLibraryData | BroadcastTimeByMediaTypeData
): data is ChartLibraryData {
  return !Array.isArray(data);
}

export function isOutreachPerformanceChartData(
  data: Nullable<ChartLibraryProps>
): data is OutreachPerformanceChartLibraryProps {
  return Boolean(
    data &&
    data.data &&
    !Array.isArray(data.data) &&
    ("media_release_names" in data.data || "media_releases_count" in data.data)
  );
}

export function isAIVisibilityTableData(
  data: Nullable<ChartLibraryProps>
): data is AIVisibilityDataTableProps {
  return Boolean(
    data && data.data && "columns" in data.data && "rows" in data.data
  );
}

export function isAIVisibilitySentimentData(
  data: Nullable<ChartLibraryProps>
): data is AIVisibilitySentimentProps {
  return Boolean(
    data &&
    data.data &&
    "fields" in data.data &&
    "datasets" in data.data &&
    Array.isArray(data.data.datasets)
  );
}

export function isDatasetsData(
  data: Nullable<ChartLibraryProps>
): data is BaseChartLibraryProps<ChartLibraryData> {
  return Boolean(
    data && data.data && "datasets" in data.data && data.data.datasets
  );
}

export function isWordCloudData(
  data: Nullable<ChartLibraryProps>
): data is WordCloudProps {
  return Boolean(data && data.words);
}

export function isLeadingSourcesDataWithContactKeys(
  data: Nullable<ChartLibraryProps>
): data is LeadingSourcesChartLibraryProps {
  return Boolean(
    data &&
    data.data &&
    "datasets" in data.data &&
    Array.isArray(data.data.datasets) &&
    data.data.datasets[0].contactKeys
  );
}

export function isLeadingSourcesTableDataWithContactKeys(
  data: Nullable<ChartLibraryProps>
): data is LeadingSourcesTableChartLibraryProps {
  return Boolean(
    data && data.data && "columns" in data.data && "contactKeys" in data.data
  );
}
